import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/engine/deals',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::index
* @see app/Http/Controllers/Admin/DealsController.php:17
* @route '/engine/deals'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\DealsController::store
* @see app/Http/Controllers/Admin/DealsController.php:55
* @route '/engine/deals'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/engine/deals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\DealsController::store
* @see app/Http/Controllers/Admin/DealsController.php:55
* @route '/engine/deals'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DealsController::store
* @see app/Http/Controllers/Admin/DealsController.php:55
* @route '/engine/deals'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::store
* @see app/Http/Controllers/Admin/DealsController.php:55
* @route '/engine/deals'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::store
* @see app/Http/Controllers/Admin/DealsController.php:55
* @route '/engine/deals'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\DealsController::update
* @see app/Http/Controllers/Admin/DealsController.php:62
* @route '/engine/deals/{deal}'
*/
export const update = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/engine/deals/{deal}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\DealsController::update
* @see app/Http/Controllers/Admin/DealsController.php:62
* @route '/engine/deals/{deal}'
*/
update.url = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { deal: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { deal: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            deal: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        deal: typeof args.deal === 'object'
        ? args.deal.id
        : args.deal,
    }

    return update.definition.url
            .replace('{deal}', parsedArgs.deal.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DealsController::update
* @see app/Http/Controllers/Admin/DealsController.php:62
* @route '/engine/deals/{deal}'
*/
update.patch = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::update
* @see app/Http/Controllers/Admin/DealsController.php:62
* @route '/engine/deals/{deal}'
*/
const updateForm = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::update
* @see app/Http/Controllers/Admin/DealsController.php:62
* @route '/engine/deals/{deal}'
*/
updateForm.patch = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\DealsController::destroy
* @see app/Http/Controllers/Admin/DealsController.php:129
* @route '/engine/deals/{deal}'
*/
export const destroy = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/engine/deals/{deal}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\DealsController::destroy
* @see app/Http/Controllers/Admin/DealsController.php:129
* @route '/engine/deals/{deal}'
*/
destroy.url = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { deal: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { deal: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            deal: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        deal: typeof args.deal === 'object'
        ? args.deal.id
        : args.deal,
    }

    return destroy.definition.url
            .replace('{deal}', parsedArgs.deal.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DealsController::destroy
* @see app/Http/Controllers/Admin/DealsController.php:129
* @route '/engine/deals/{deal}'
*/
destroy.delete = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::destroy
* @see app/Http/Controllers/Admin/DealsController.php:129
* @route '/engine/deals/{deal}'
*/
const destroyForm = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DealsController::destroy
* @see app/Http/Controllers/Admin/DealsController.php:129
* @route '/engine/deals/{deal}'
*/
destroyForm.delete = (args: { deal: number | { id: number } } | [deal: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const deals = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default deals